

























import { Vue } from "vue-property-decorator";
import type { stadium_ground } from "@/@types/stadium/ground"

export default Vue.extend({
  name : "InvestLogInfo",
  props: {
    width     : { type: String, default: "520px" },
    stadium_id: { type: String, required: true },
    sn        : { type: Number, default: 1 },
  },
  data() {
    return {
      form: {
        id         : 0,
        stadium_id : 0,
        sn         : 0,
        name       : "",
        description: "",
        service_url: "",
        stage      : 0,
        status     : 1,
      } as stadium_ground,
      visible: false,
      loading: false,
      options: [
        // { label: '未知', value: '0' },
        { label: '上线', value: 1 },
        { label: '下线', value: 0 },
      ],
      content_icons: {
        审核中 : { icon: "clock-circle", color: "#10aeff" },
        已通过 : { icon: "check-circle", color: "#4cd964" },
        未通过 : { icon: "close-circle", color: "#f6383a" },
      }
    }
  },
  methods: {
    open(id: number) {
      this.$nextTick(() => {
        if (id > 0) this.info(id)
        else {
          this.form.sn = this.sn
          this.form.stadium_id = Number(this.stadium_id)
        }
        this.visible = true
        this.loading = false
      })
    },
    async info(id: number) {
      const params = { id }
      const res = await this.$store.dispatch("stadium/getGround", params);
      if (res.Code == 200) {
        this.form = res.Data
      }
    },
    async submit() {
      this.$emit("add", this.form)
      this.loading = false
      this.visible = false
      /* this.loading = true
      this.form.stadium_id = Number(this.stadium_id)
      let res = {} as any
      if (this.form.id > 0) {
        res = await this.$store.dispatch("stadium/editGround", this.form);
      } else {
        res = await this.$store.dispatch("stadium/addGround", this.form);
      }
      if (res.Code == 200) this.$success({ content: "保存成功" })
      else this.$error({ content: res.Message })
      this.loading = false
      this.visible = false
      this.$emit("refresh") */
    }
  }
})

